function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Get interiorNav
var interiorNav = document.querySelector('.js-inner-nav');
var asideNav = document.querySelector('.js-aside-nav');

// Check if interiorNav is on page
if (interiorNav) {
    // Get Links in interiorNav
    // This is for Vertical Nav
    // | item | item | item |
    var initScroll = function initScroll() {
        let interiorNavLink = Array.prototype.slice.call(document.querySelectorAll('.inner-nav__link'));
        // Create array of anchors
        let anchors = interiorNavLink.map((link) => {
            return link.hash;
        });

        // Fn
        // Remove Selected Links
        var removeSelectedLink = function removeSelectedLink() {
            for (var i = 0; i < interiorNavLink.length; i++) {
                interiorNavLink[i].removeAttribute('link-selected');
            }
        };
        // Init Smooth Scroll
        //var scroll = new _jsLibSmoothScrollTo2['default']('.inner-nav__link', {
        //    offset: 20
        //});

        // Get interiorNav location from Top
        var interiorNavTopLocation = 410;

        // fn - Detect interiorNav
        var interiorNavDetect = function interiorNavDetect() {
            // Get BodyTop on Scroll
            var bodyTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
            // add a buffer for 40px (padding of article)	
            var anchorBuffer = 40;
            // for anchors loop
            for (var i = 0; i < anchors.length; i++) {
                // each anchor
                var anchor = anchors[i];
                // each <a> with href
                var href = document.querySelector('a.inner-nav__link[href="' + anchor + '"]');
                // anchors are corrected in CSS to make up for floating Nav
                // so we calculate by Top of Element + ( height of nav correction which is negative )
                // let anchorTop = document.querySelector(anchor).parentElement.offsetTop + document.querySelector(anchor).offsetTop;
                var anchorTop = document.querySelector(anchor).getClientRects()[0].top;

                if (anchorTop <= 210) {
                    removeSelectedLink();
                    href.setAttribute('link-selected', true);
                }
            }
            // Scroll Dectect to Pin interiorNav
            if (bodyTop > interiorNavTopLocation) {
                interiorNav.setAttribute('scrolled', true);
            } else {
                interiorNav.removeAttribute('scrolled');
            }
        };

        // Add Listeners
        if (interiorNav.dataset.internal) {
            document.addEventListener('scroll', interiorNavDetect, false);
        }
    };

    // This is for Aside Nav on Page
    // It is auto generated from User Content <h2> and <h3>
    if (asideNav) {
        var createAsideNav = function createAsideNav() {
            var linkedContent = document.getElementById('js-linked-content');
            var anchorsInContent = linkedContent.querySelectorAll('h2, h3');
            if (anchorsInContent.length > 0) {
                // Add section content
                // Create unique ids
                for (var i = 0; i < anchorsInContent.length; i++) {
                    if (!anchorsInContent[i].classList.contains('nav-unlink')) {
                        var text = anchorsInContent[i].innerText;
                        var href = text.replace(/ /g, '+');
                        anchorsInContent[i].setAttribute('id', href);
                        asideNav.innerHTML = asideNav.innerHTML + '<li><a class="inner-nav__link" data-scroll href="#' + href + '">' + text + '</a></li>';
                    }
                }
                // Add 'on this page' title
                var asideNavTitle = document.createElement('h3');
                asideNavTitle.innerText = 'On This Page';
                asideNav.parentNode.insertBefore(asideNavTitle, asideNav);
            }
        };
        createAsideNav();
        var _scroll = new _jsLibSmoothScrollTo2['default']('.inner-nav__link', {
            offset: 20
        });
    } else {
        initScroll();
    }
}


// WEBPACK FOOTER //
// ../components/inner-nav/inner-nav.js